export default __webpack_public_path__ + "static/media/kitchen2-2048w.7c670d6f.png";